import { Box, AspectRatio } from "@mantine/core";

interface VideoEmbedProps {
  videoId?: string;
  videoid?: string;
  platform?: "youtube" | "vimeo";
  title?: string;
}

export function VideoEmbed({ videoId, videoid, platform = "youtube", title }: VideoEmbedProps) {
  const id = videoId ?? videoid;
  if (!id) return null;
  const embedUrl =
    platform === "youtube"
      ? `https://www.youtube.com/embed/${id}`
      : `https://player.vimeo.com/video/${id}`;

  return (
    <Box my="xl">
      <AspectRatio ratio={16 / 9}>
        <iframe
          src={embedUrl}
          title={title ?? "Video"}
          style={{ border: "none", borderRadius: 12 }}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </AspectRatio>
      {title && (
        <Box style={{ fontSize: 13, color: "#888", marginTop: 8, textAlign: "center" }}>
          {title}
        </Box>
      )}
    </Box>
  );
}
